import { cn } from "@/lib/utils";
import { JSX } from "react";

interface Props {
  image: JSX.Element;
  title: string;
  description: string;
  className?: string;
  headerClassName?: string;
}

const NoData = ({
  image,
  title,
  description,
  className,
  headerClassName,
}: Props) => {
  return (
    <div className={`flex-center flex-col text-center ${className}`}>
      <div className={cn("mb-3 p-4 rounded-20 flex-center", headerClassName)}>
        {image}
      </div>
      <h2 className="text-lg text-center font-semibold leading-130 text-white">
        {title}
      </h2>
      <p className="text-gray-1 text-center text-sm leading-130 font-normal mt-1">
        {description}
      </p>
    </div>
  );
};

export default NoData;
